module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"title":"신고/차단하기","already_blocked":"이미 신고/차단한 게시물입니다.","cancel":"취소","submit":"신고","error":"신고 접수가 실패했습니다. 입력값을 확인해주세요."}}')
  delete Component.options._Ctor
}
